import React from 'react'

const NeutralBlank = () => (
  <div aria-busy="true" data-testid="neutral-blank" style={{ minHeight: '100vh' }} />
)

export default NeutralBlank
